import React, {FC} from "react"

import id from "@irati/utils/id"
import Spacing from "../Spacing"
import Icon, {IconProps} from "../Icon"
import Text, {TextProps} from "./Text"
import {TextHelper, TextHelperProps} from "./styled"

export interface Props extends TextProps, IconProps, TextHelperProps {
  id?: string
  iconPosition?: "left" | "right"
  hasError?: boolean
}

const IconText: FC<Props> = (props) => {
  const idNamespace = id("icon-text", props)
  const {id: _id, icon, iconPosition, ...componentProps} = props

  const iconElement = (
    <Spacing marginRight={1}>
      <Icon icon={props?.icon} {...componentProps} id={id("icon", idNamespace)} />
    </Spacing>
  )
  const isRightSidedIcon = iconPosition === "right"

  return (
    <TextHelper {...componentProps} id={idNamespace} overflowWrap="break-word">
      {!isRightSidedIcon && iconElement}
      <Text>{props.children}</Text>
      {isRightSidedIcon && iconElement}
    </TextHelper>
  )
}

IconText.defaultProps = {
  size: 16,
  iconPosition: "left",
  values: {}
}

export default IconText
